module.exports = "<div class=\"app\" screenSize scrollControl>\n    <app-header></app-header>\n    <router-outlet></router-outlet>\n    <router-outlet name=\"popup\"></router-outlet>\n    <app-footer></app-footer>\n</div>"


//////////////////
// WEBPACK FOOTER
// /var/lib/jenkins/jobs/(IGH Projects)/jobs/EVFS PROD_FRONTEND granima.de/workspace/frontend/src/app/app.component.html
// module id = ../../../../../src/app/app.component.html
// module chunks = main